import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import * as styles from './style';
import ActionBtn from '../../../components/ActionBtn';
import { VARIATIONS_OPTIONS_ACTIONS_TYPE } from '../../../helpers/constants';
import { priceToInt, formatPrice } from '../../../helpers/price';
import { BLUE_LIGHTER } from '../../../styles/variables';

const VariationOptionItem = ({ index, option, onEdit, onRemove, currentEditingId }) => {
  const [opened, setOpened] = useState(false);
  const showToggleText = option.desc && option.desc.length > 30;
  const editing = currentEditingId && option.id === currentEditingId;

  const onClickOptionActions = type => {
    let action = {};
    VARIATIONS_OPTIONS_ACTIONS_TYPE.forEach(item => {
      action[item.type] = item.type;
    });

    switch (type) {
      case action.edit:
        onEdit(option.id);
        break;
      case action.delete:
        onRemove(index);
        break;
      default:
        break;
    }
  };

  return (
    <styles.OptionListItem>
      {editing ? (
        <styles.OptionListItemData>
          <styles.OptionListItemField fullWidth>{'Editando...'}</styles.OptionListItemField>
        </styles.OptionListItemData>
      ) : (
        <Fragment>
          <styles.OptionListItemData>
            <styles.NameField>{option.name}</styles.NameField>
            {option.sku && (
              <styles.OptionListItemField noShrink>cód. {option.sku}</styles.OptionListItemField>
            )}
            <styles.OptionPriceField noShrink hasSku={option.sku}>
              {formatPrice(priceToInt(option.originalPrice) / 100)}
            </styles.OptionPriceField>
            <ActionBtn
              className="variation-item-action-btn"
              id={`variation-item-action-btn-${option.sku}`}
              items={VARIATIONS_OPTIONS_ACTIONS_TYPE}
              onClick={onClickOptionActions}
              buttonStyle={{
                height: '15px',
                width: 'auto',
                marginLeft: !option.sku ? '25px' : '',
                div: {
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                },
              }}
              dotStyle={{
                backgroundColor: BLUE_LIGHTER,
                marginRight: '3px',
              }}
              hoverStyle={{
                backgroundColor: BLUE_LIGHTER,
              }}
            />
          </styles.OptionListItemData>
          {option.desc && (
            <styles.OptionListItemDescription className={(opened || !showToggleText) && 'opened'}>
              <styles.OptionListItemDescriptionContent>
                {option.desc}
              </styles.OptionListItemDescriptionContent>
              {showToggleText && (
                <styles.OptionListItemDescriptionButton
                  type="button"
                  onClick={() => setOpened(!opened)}
                >
                  {opened ? 'Fechar' : 'Mostrar'}
                </styles.OptionListItemDescriptionButton>
              )}
            </styles.OptionListItemDescription>
          )}
        </Fragment>
      )}
    </styles.OptionListItem>
  );
};

VariationOptionItem.propTypes = {
  option: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default VariationOptionItem;



// WEBPACK FOOTER //
// ./src/components/VariationOptionForm/VariationOptionItem/index.js